/* Tee 95 — storefront behaviour. No dependencies.
   window.W95 (money format + routes) is set in layout/theme.liquid. */
(function () {
  'use strict';

  var W95 = (window.W95 = window.W95 || {});
  W95.routes = W95.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add.js' };

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---- money ----------------------------------------------------------- */
  function formatNumber(cents, decimals, thousands, point) {
    var parts = (cents / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(point);
  }
  W95.money = function (cents) {
    var format = W95.moneyFormat || '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return formatNumber(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return formatNumber(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return formatNumber(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return formatNumber(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return formatNumber(cents, 0, ' ', '.');
        case 'amount_with_space_separator': return formatNumber(cents, 2, ' ', ',');
        default: return formatNumber(cents, 2, ',', '.');
      }
    });
  };

  /* ---- tray clock ------------------------------------------------------ */
  function tick() {
    var now = new Date();
    var text = now.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    $$('[data-w95-clock]').forEach(function (el) { el.textContent = text; });
  }
  tick();
  setInterval(tick, 15000);

  /* ---- Start menu ------------------------------------------------------ */
  var startBtn = $('[data-w95-start]');
  var startMenu = $('[data-w95-startmenu]');
  function setStart(open) {
    if (!startBtn || !startMenu) return;
    startMenu.hidden = !open;
    startBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var first = $('a, button', startMenu); if (first) first.focus(); }
  }
  if (startBtn && startMenu) {
    startBtn.addEventListener('click', function () { setStart(startMenu.hidden); });
    document.addEventListener('click', function (e) {
      if (!startMenu.hidden && !startMenu.contains(e.target) && !startBtn.contains(e.target)) setStart(false);
    });
  }

  /* ---- windows: open, close, drag ------------------------------------- */
  var zTop = 100; // above the pop-ups (30) and the minimized dock (15), below the taskbar (900)
  function raise(win) { win.style.zIndex = String(++zTop); }

  // Windows the visitor opens (icons) or restores (dock) are shown centred in the visible area,
  // on top of everything, so their title bar and close button are never covered.
  function centerWindow(win) {
    var bar = $('.w95-taskbar');
    var viewW = document.documentElement.clientWidth, viewH = window.innerHeight - (bar ? bar.offsetHeight : 0);
    win.style.transform = '';
    win.dispatchEvent(new Event('w95-reset'));
    win.style.position = 'fixed';
    win.style.right = 'auto'; win.style.bottom = 'auto'; win.style.marginLeft = '0';
    win.style.left = Math.max(10, Math.round((viewW - win.offsetWidth) / 2)) + 'px';
    win.style.top = Math.max(10, Math.round((viewH - win.offsetHeight) / 2)) + 'px';
  }

  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-w95-close]');
    if (closer) {
      var win = closer.closest('[data-w95-window]');
      if (win) { win.hidden = true; e.preventDefault(); }
      return;
    }
    var opener = e.target.closest('[data-w95-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-w95-open'));
      if (target) {
        target.hidden = false;
        raise(target);
        centerWindow(target);
        var focusable = $('[data-w95-close]', target);
        if (focusable) focusable.focus();
      }
    }
  });

  var canDrag = window.matchMedia('(min-width: 1100px) and (pointer: fine)');
  $$('[data-w95-drag]').forEach(function (win) {
    var bar = $('.w95-titlebar', win);
    if (!bar) return;
    var x = 0, y = 0, startX = 0, startY = 0, dragging = false;
    win.addEventListener('w95-reset', function () { x = 0; y = 0; });
    bar.addEventListener('pointerdown', function (e) {
      if (!canDrag.matches || e.target.closest('.w95-titlebar__controls')) return;
      dragging = true; startX = e.clientX - x; startY = e.clientY - y;
      raise(win);
      bar.setPointerCapture(e.pointerId);
    });
    bar.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      x = e.clientX - startX; y = e.clientY - startY;
      win.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    });
    ['pointerup', 'pointercancel'].forEach(function (type) {
      bar.addEventListener(type, function () { dragging = false; });
    });
    win.addEventListener('pointerdown', function () { raise(win); });
  });

  /* ---- message box ----------------------------------------------------- */
  var modal = $('[data-w95-modal]');
  var lastFocus = null;
  W95.message = function (opts) {
    if (!modal) { window.alert(opts.text); return; }
    lastFocus = document.activeElement;
    $('[data-w95-modal-title]', modal).textContent = opts.title || '';
    $('[data-w95-modal-text]', modal).textContent = opts.text || '';
    var icon = $('[data-w95-modal-icon]', modal);
    icon.src = modal.getAttribute('data-icon-' + (opts.icon || 'info')) || icon.src;
    var actions = $('[data-w95-modal-actions]', modal);
    actions.innerHTML = '';
    (opts.buttons || [{ label: 'OK' }]).forEach(function (b, i) {
      var el = document.createElement(b.href ? 'a' : 'button');
      el.className = 'w95-btn' + (i === 0 ? ' w95-btn--default' : '');
      el.textContent = b.label;
      if (b.href) el.href = b.href; else { el.type = 'button'; el.addEventListener('click', closeMessage); }
      actions.appendChild(el);
    });
    modal.hidden = false;
    var first = $('.w95-btn', actions);
    if (first) first.focus();
  };
  function closeMessage() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-w95-modal-close]')) closeMessage();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (modal && !modal.hidden) { closeMessage(); return; }
    if (startMenu && !startMenu.hidden) { setStart(false); startBtn.focus(); }
  });

  /* ---- collection sort ------------------------------------------------- */
  $$('[data-w95-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  /* ---- product page ---------------------------------------------------- */
  function setCartCount(count) {
    $$('[data-w95-cart-count]').forEach(function (el) { el.textContent = String(count); });
  }

  $$('[data-w95-product]').forEach(function (root) {
    var form = $('form.w95-product-form', root);
    var idInput = form && $('input[name="id"]', form);
    var addBtn = $('[data-w95-add]', root);
    var priceEl = $('[data-w95-price]', root);
    var mainImage = $('[data-w95-main-image]', root);
    var variants = [];
    try { variants = JSON.parse($('[data-w95-variants]', root).textContent); } catch (err) { variants = []; }

    function showImage(src, alt) {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = src;
      if (alt != null) mainImage.alt = alt;
    }

    // thumbnails
    $$('[data-w95-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showImage(thumb.getAttribute('data-src'), thumb.getAttribute('data-alt'));
        $$('[data-w95-thumb]', root).forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    // option buttons -> variant
    function selectedOptions() {
      return $$('[data-w95-option]', root).map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }
    function renderVariant(variant) {
      if (!addBtn) return;
      if (!variant) {
        addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-label-unavailable') || 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available
        ? (addBtn.getAttribute('data-label-add') || 'Add to cart')
        : (addBtn.getAttribute('data-label-soldout') || 'Sold out');
      if (priceEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceEl.innerHTML =
          '<span class="w95-price' + (onSale ? ' w95-price--sale' : '') + '">' +
          (onSale ? '<s>' + W95.money(variant.compare_at_price) + '</s>' : '') +
          W95.money(variant.price) + '</span>' +
          (variant.available ? '' : '<span class="w95-badge">Sold out</span>');
      }
      if (variant.featured_image && variant.featured_image.src) {
        showImage(variant.featured_image.src, variant.featured_image.alt || '');
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-w95-option] input', root).forEach(function (input) {
      input.addEventListener('change', function () {
        var chosen = selectedOptions();
        var match = variants.filter(function (v) {
          return v.options.every(function (value, i) { return value === chosen[i]; });
        })[0];
        renderVariant(match || null);
      });
    });

    // add to cart without leaving the page
    if (form && window.fetch && window.FormData) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.name && e.submitter.name !== 'add') return; // dynamic checkout etc.
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        fetch(W95.routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (res) {
            if (addBtn) addBtn.disabled = false;
            if (!res.ok) {
              W95.message({ title: 'Cart', icon: 'error', text: res.data.description || res.data.message || 'That item could not be added to your cart.' });
              return;
            }
            var title = res.data.product_title || 'Item';
            W95.message({
              title: 'Cart', icon: 'info',
              text: title + ' was added to your cart.',
              buttons: [{ label: 'View cart', href: W95.routes.cart }, { label: 'Keep shopping' }]
            });
            return fetch(W95.routes.cart + '.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) { setCartCount(cart.item_count); });
          })
          .catch(function () { form.submit(); }); // network problem: fall back to a normal form post
      });
    }
  });

  /* ---- click sound ------------------------------------------------------- */
  // Plays assets/click.wav on every press. A small pool lets fast clicks overlap.
  // Browsers only allow sound after the visitor has clicked once, which a click sound always satisfies.
  var cfg = W95.sound || {};
  var sound = (W95.soundState = { plays: 0, muted: false });
  try { sound.muted = window.localStorage.getItem('w95-sound') === 'off'; } catch (e) { /* storage blocked */ }
  var pool = [], poolAt = 0;
  if (cfg.enabled && cfg.src && window.Audio) {
    for (var p = 0; p < 4; p++) {
      var a = new Audio(cfg.src);
      a.preload = 'auto';
      a.volume = typeof cfg.volume === 'number' ? Math.max(0, Math.min(1, cfg.volume)) : 0.6;
      pool.push(a);
    }
  }
  function playClick() {
    if (!pool.length || sound.muted) return;
    var a = pool[poolAt++ % pool.length];
    try {
      a.currentTime = 0;
      var result = a.play();
      if (result && result.catch) result.catch(function () { /* blocked until the first gesture */ });
      sound.plays++;
    } catch (e) { /* ignore */ }
  }
  var soundBtn = $('[data-w95-sound-toggle]');
  function renderSound() {
    if (!soundBtn) return;
    soundBtn.setAttribute('aria-pressed', sound.muted ? 'true' : 'false');
    soundBtn.setAttribute('aria-label', 'Click sound: ' + (sound.muted ? 'off' : 'on'));
  }
  renderSound();
  if (soundBtn) {
    soundBtn.addEventListener('click', function () {
      sound.muted = !sound.muted;
      try { window.localStorage.setItem('w95-sound', sound.muted ? 'off' : 'on'); } catch (e) { /* storage blocked */ }
      renderSound();
      if (!sound.muted) playClick();
    });
  }
  // Only selecting an icon, closing a window or pressing a button / link inside a pop-up makes a sound (desktop icons,
  // minimized pop-up icons, title-bar close / minimize buttons, message-box buttons, pop-up buttons and links),
  // never scrolling or touching blank space.
  // pointerup fires for a real tap or click; a touch that turns into a scroll ends in pointercancel and stays silent.
  var SOUND_TARGETS = '.w95-dicon, .m-dockbtn, .w95-ctl, .w95-msgbox .w95-btn, .m-virus a, .m-virus button';
  var isSoundTarget = function (el) { return !!(el && el.closest && el.closest(SOUND_TARGETS)); };
  document.addEventListener('pointerup', function (e) {
    if (e.button > 0) return; // right-click
    if (isSoundTarget(e.target)) playClick();
  }, true);
  document.addEventListener('click', function (e) {
    if (!isSoundTarget(e.target)) return;
    if (e.detail === 0) playClick(); // keyboard: Enter / Space on a focused icon

    // A link that opens another page in this tab waits a moment so the click is heard before the page unloads.
    var link = e.target.closest('a[href]');
    if (!link || !pool.length || sound.muted || e.defaultPrevented) return;
    if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var targetAttr = link.getAttribute('target');
    var href = link.getAttribute('href');
    if ((targetAttr && targetAttr !== '_self') || !href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return;
    e.preventDefault();
    setTimeout(function () { window.location.assign(link.href); }, 110);
  }, true);

  /* ---- Moronica virus pop-ups ------------------------------------------ */
  // Each pop-up appears after its delay. Closing or minimizing sends it to a small dock in the top-right corner
  // (kept out of the taskbar so it never covers the sound button or the cart); its flashing icon brings it back.
  // Minimized pop-ups stay minimized for the visit.
  var store = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* storage blocked */ } }
  };
  var dock = null;

  function virusButton(win) {
    if (!dock) {
      dock = document.createElement('div');
      dock.className = 'm-dock';
      dock.setAttribute('role', 'group');
      dock.setAttribute('aria-label', 'Minimized pop-ups');
      document.body.appendChild(dock);
    }
    var btn = $('[data-m-task="' + win.id + '"]', dock);
    if (btn) return btn;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'm-dockbtn';
    btn.hidden = true;
    btn.setAttribute('data-m-task', win.id);
    btn.setAttribute('aria-label', 'Restore ' + (win.getAttribute('data-title') || 'window'));
    btn.title = win.getAttribute('data-title') || '';
    var img = document.createElement('img');
    img.className = 'w95-ico'; img.width = 32; img.height = 32; img.alt = '';
    img.src = win.getAttribute('data-icon') || '';
    btn.appendChild(img);
    btn.addEventListener('click', function () { showVirus(win); });
    dock.appendChild(btn);
    return btn;
  }
  function showVirus(win, arriving) {
    win.hidden = false;
    raise(win);
    var btn = virusButton(win);
    if (btn) btn.hidden = true;
    store.set('m-virus-' + win.id, 'open');
    if (arriving) {
      win.classList.add('is-arriving');
      setTimeout(function () { win.classList.remove('is-arriving'); }, 500);
    } else {
      centerWindow(win); // restored from the dock: show it centred and fully visible
    }
  }
  function minimizeVirus(win) {
    win.hidden = true;
    var frame = $('iframe', win);
    if (frame) frame.parentNode.removeChild(frame); // stop a playing video
    var btn = virusButton(win);
    if (btn) { btn.hidden = false; btn.focus(); }
    store.set('m-virus-' + win.id, 'min');
  }

  var inEditor = window.Shopify && window.Shopify.designMode;

  // A refresh (or ?popups=reset on the address) starts the show over. Moving between pages keeps closed pop-ups closed.
  var navEntry = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  if ((navEntry && navEntry.type === 'reload') || /[?&]popups=reset\b/.test(window.location.search)) {
    try {
      for (var k = window.sessionStorage.length - 1; k >= 0; k--) {
        var key = window.sessionStorage.key(k);
        if (key && key.indexOf('m-virus-') === 0) window.sessionStorage.removeItem(key);
      }
    } catch (e) { /* storage blocked */ }
  }

  $$('[data-m-virus]').forEach(function (win) {
    if (store.get('m-virus-' + win.id) === 'min' && !inEditor) { virusButton(win).hidden = false; return; }
    var delay = inEditor ? 0 : parseFloat(win.getAttribute('data-delay')) || 0;
    setTimeout(function () { showVirus(win, true); }, delay * 1000);
  });
  document.addEventListener('click', function (e) {
    var min = e.target.closest('[data-m-virus-min]');
    if (min) { minimizeVirus(min.closest('[data-m-virus]')); return; }

    var yt = e.target.closest('[data-m-yt]');
    if (yt) {
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(yt.getAttribute('data-m-yt')) + '?autoplay=1&playsinline=1&rel=0';
      frame.title = yt.getAttribute('aria-label') || 'YouTube video';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      $$('img, .m-yt__play', yt).forEach(function (el) { el.hidden = true; });
      yt.appendChild(frame);
      return;
    }

    var copy = e.target.closest('[data-m-copy]');
    if (copy) {
      var code = copy.getAttribute('data-m-copy');
      var done = function () {
        var label = copy.textContent;
        copy.textContent = copy.getAttribute('data-label-done') || 'Copied!';
        setTimeout(function () { copy.textContent = label; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, function () {});
    }
  });

  /* ---- 404 blue screen: any key returns to the desktop ------------------ */
  var bsod = $('[data-w95-bsod]');
  if (bsod) {
    document.addEventListener('keydown', function (e) {
      if (bsod.offsetParent === null) return; // not on screen
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if (['Tab', 'Shift', 'Escape'].indexOf(e.key) !== -1) return;
      if (e.target.closest && e.target.closest('input, textarea, select, a, button, [data-w95-startmenu]')) return;
      window.location.assign(bsod.getAttribute('data-home') || W95.routes.root);
    });
  }
})();
